module.exports = __webpack_public_path__ + "img/Veranza-20-min.538a7fac.jpg";